/** Local YYYY-MM-DD helpers for HTML date inputs (avoids UTC off-by-one). */

export function toDateInputValue(value) {
  if (value == null || value === "") return "";
  const raw = String(value).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) return raw;

  // Prefer the calendar date portion when the API sends a date-only / midnight string.
  if (/^\d{4}-\d{2}-\d{2}/.test(raw) && !/[T ]\d{2}:\d{2}:\d{2}/.test(raw)) {
    return raw.slice(0, 10);
  }

  const date = new Date(raw);
  if (Number.isNaN(date.getTime())) {
    return /^\d{4}-\d{2}-\d{2}/.test(raw) ? raw.slice(0, 10) : "";
  }

  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function todayInputValue() {
  const date = new Date();
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function yearsFromTodayInputValue(years) {
  const date = new Date();
  date.setFullYear(date.getFullYear() + years);
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

/** Returns an error message or "" if education dates are valid. */
export function validateEducationDates(yearOfStarting, yearOfPassing) {
  const start = toDateInputValue(yearOfStarting);
  const pass = toDateInputValue(yearOfPassing);
  const today = todayInputValue();

  if (!start) return "Please select year of starting.";
  if (!pass) return "Please select year of passing.";
  if (start > today) return "Year of starting cannot be a future date.";
  if (pass < start) return "Year of passing must be on or after year of starting.";
  if (pass > yearsFromTodayInputValue(15)) {
    return "Year of passing cannot be more than 15 years in the future.";
  }
  return "";
}

/** YYYY-MM-DD strictly after the given date (for expiry min). */
export function dayAfterInputValue(value) {
  const base = toDateInputValue(value);
  if (!base) return "";
  const d = new Date(`${base}T00:00:00`);
  if (Number.isNaN(d.getTime())) return "";
  d.setDate(d.getDate() + 1);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

/** Returns an error message or "" if certification dates are valid. Expiry is optional. */
export function validateCertificationDates(issueDate, expiryDate) {
  const issue = toDateInputValue(issueDate);
  const expiry = toDateInputValue(expiryDate);
  const today = todayInputValue();

  if (!issue) return "Please select issue date.";
  if (issue > today) return "Issue date cannot be a future date.";
  if (expiry && expiry <= issue) {
    return "Expiry date must be greater than issue date.";
  }
  return "";
}
